import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function PuffPastryVegetableTart() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Puff Pastry Vegetable Tart</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>1 x 500 g block of
        ready-made puff pastry<br></br>
        plain flour , for dusting<br></br>4 teaspoons pesto<br></br>1 handful of
        mixed, ripe cherry tomatoes<br></br>8 asparagus spears<br></br>4 baby
        courgettes<br></br>
        2-3 jarred roasted peppers<br></br>½ a bunch of fresh basil<br></br>
        olive oil<br></br>8 black olives , optional<br></br>1 x 100 g ball
        mozzarella<br></br>
        20 g Parmesan cheese , optional<br></br>
      </Typography>

      <Typography>
        Turn on the oven to 200ºC/gas 6. Carefully cut the pastry block in half
        with a table knife. Wrap the other half and refrigerate or freeze for
        later.
        <br></br>
        Dust some flour onto a clean work surface and, using a rolling pin, roll
        out the pastry into a square, measuring 26cm x 26cm. Cut into 4 equal
        squares.
        <br></br>
        Place the pastry squares on a baking tray, leaving a space between each.
        <br></br>
        Using the back of a spoon, spread the centre of each square with pesto,
        but don't spread it onto the edges.
        <br></br>
        Squash the tomatoes into a large mixing bowl, then snap the asparagus
        spears into 3cm pieces. Keep the lovely pointy tips and a little of the
        stalk, but discard the end 3cm.
        <br></br>
        Using a speed peeler, carefully shred the courgettes into ribbons. Tear
        the roasted peppers into strips and add to the bowl.
        <br></br>
        Pick the basil leaves, reserving the pretty ones for later. Place the
        large ones in the mixing bowl.
        <br></br>
        Mix the vegetables together in the bowl, adding a splash of oil. Pile a
        little of the mixture on each pesto-smeared tart and top with two olives
        .<br></br>
        Break up the mozzarella and place little bits on top of each tart - this
        will make it gooey like a pizza. Grate over some Parmesan .<br></br>
        Bake for 15 to 20 minutes, until the pastry is golden and the cheese is
        all bubbly.
        <br></br>
        Once the tarts are ready, allow to cool slightly. Sprinkle with the
        reserved basil leaves and serve with a nice salad for lunch.
        <br></br>
      </Typography>
    </Card>
  );
}
